import clsx from 'clsx';
import type { ReactNode } from 'react';

import { Icon, type IconName } from './Icon';
import styles from './StatusView.module.css';

export type StatusTone = 'neutral' | 'danger' | 'warning' | 'accent';

export interface StatusViewProps {
  icon: IconName;
  title: string;
  message?: ReactNode;
  tone?: StatusTone;
  compact?: boolean;
  action?: ReactNode;
  className?: string;
}

/**
 * The one component every empty / error / permission state in the app uses,
 * so those states look deliberate rather than improvised.
 */
export function StatusView({
  icon,
  title,
  message,
  tone = 'neutral',
  compact = false,
  action,
  className,
}: StatusViewProps) {
  return (
    <div className={clsx(styles.wrapper, compact && styles.compact, className)} role="status">
      <span className={clsx(styles.iconWrap, styles[tone])}>
        <Icon name={icon} size={24} />
      </span>
      <p className={styles.title}>{title}</p>
      {message ? <p className={styles.message}>{message}</p> : null}
      {action ? <div className={styles.action}>{action}</div> : null}
    </div>
  );
}
